import { React, useState, useEffect } from 'react';
import TextInputField from '../../TextInputField';
import PasswordInputField from '../../PasswordInputField';
import './SignUpPage.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Checkmark from '../PostNewItemPage/Checkmark';
import Footer from '../../footer/Footer';
import { useMutation } from '@tanstack/react-query';
import parsePhoneNumber from 'libphonenumber-js';
import ViewPasswordIcon from '../../../../public/icons/ViewPasswordIcon';
import HidePasswordIcon from '../../../../public/icons/HidePasswordIcon';
import Api from '../../Api/Api';
import LoadingCircle from '../../assetComponents/LoadingCircle';
import { useToken } from '../../auth/useToken';
// import DropDownLocation from '../Nav/Settings/MyAccountInfo/DropDownLocation';
// import { options } from '../Nav/Settings/MyAccountInfo/Locations';
import DropDownLocation from '../Settings/MyAccountInfo/DropDownLocation';
import { options } from '../Settings/MyAccountInfo/Locations';

/*---Sign up page 1---*/
export default function SignUpPage() {
  //---state---//
  const [firstName, setFirstName] = useState('');
  const [isFirstNameValid, setIsFirstNameValid] = useState(true);
  const [firstNameError, setFirstNameError] = useState('');
  const [surname, setSurname] = useState('');
  const [isSurnameValid, setIsSurnameValid] = useState(true);
  const [surnameError, setSurnameError] = useState('');
  const [email, setEmail] = useState('');
  const [isEmailvalid, setIsEmailValid] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [response, setResponse] = useState('');

  //---hooks---//
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  //---functions---//

  const handleFirstNameChange = (e) => {
    const enteredFirstName = e.target.value;
    setFirstName(enteredFirstName);

    // Validation criteria for the first name
    if (!/^[a-zA-ZÀ-ÿ' -]{1,50}$/.test(enteredFirstName)) {
      setIsFirstNameValid(false);
      setFirstNameError(
        'First name can only contain letters, spaces, hyphens, and apostrophes, and must be between 1 and 50 characters long.'
      );
    } else {
      setIsFirstNameValid(true);
      setFirstNameError('');
    }
  };

  const handleSurnameChange = (e) => {
    const enteredSurname = e.target.value;
    setSurname(enteredSurname);

    // Validation criteria for the surname
    if (!/^[a-zA-ZÀ-ÿ' -]{1,50}$/.test(enteredSurname)) {
      setIsSurnameValid(false);
      setSurnameError(
        'Surname can only contain letters, spaces, hyphens, and apostrophes, and must be between 1 and 50 characters long.'
      );
    } else {
      setIsSurnameValid(true);
      setSurnameError('');
    }
  };

  const handleEmailChange = (e) => {
    const enteredEmail = e.target.value;
    setEmail(enteredEmail);
    //Check email validity
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(enteredEmail));
  };

  const handlePhoneNumberChange = (e) => {
    const enteredPhoneNumber = e.target.value;
    setPhoneNumber(enteredPhoneNumber);
    // Check if the phone number starts with +263 or 0
    const startsWithPlus263 = enteredPhoneNumber.startsWith('+263');
    const startsWithZero = enteredPhoneNumber.startsWith('0');
    try {
      // Parse the phone number accordingly
      const parsedPhoneNumber = parsePhoneNumber(
        enteredPhoneNumber,
        startsWithPlus263 ? 'ZZ' : 'ZW' // 'ZZ' for international, 'ZW' for Zimbabwe
      );
      setIsPhoneNumberValid(parsedPhoneNumber.isValid());
    } catch (error) {
      setIsPhoneNumberValid(false);
    }
  };

  // Checking if the Next button is enabled
  const isNextButtonEnabled = () => {
    return (
      firstName.length > 0 &&
      surname.length > 0 &&
      email &&
      isEmailvalid &&
      phoneNumber &&
      isPhoneNumberValid
    );
  };

  // Checking email availability
  const checkEmailAvailability = async (email) => {
    try {
      const response = await Api.get(`/users/verify-mail/${email}`);
      if (
        response.data.code === 'SUCCESS' &&
        response.data.message === 'Email not found'
      ) {
        // Email available
        return true;
      } else if (
        response.data.code === 'SUCCESS' &&
        response.data.message === 'Email already exists'
      ) {
        // Email not available
        return false;
      } else {
        // Handle other error cases
        console.error(
          'Error checking email availability:',
          response.data.code,
          response.data.message
        );
        // Block user in case of any error
        throw new Error('Error checking email availability');
      }
    } catch (error) {
      console.error('Error checking email availability:', error.message);
      // Block user in case of any error
      throw new Error('Error checking email availability');
    }
  };

  // Navigate to next page with current page state
  const nextPage = async (e) => {
    e.preventDefault();
    const user = {
      firstName,
      lastName: surname,
      email,
      phoneNumber,
    };
    // Check if the conditions are met before navigating
    if (isNextButtonEnabled()) {
      const isEmailAvailable = await checkEmailAvailability(email);

      if (isEmailAvailable) {
        navigate('/swapandtop/signup2', { state: user });
      } else {
        setResponse('Email address is already in use.');
      }
    }
  };

  return (
    <>
      <div className='pageWrapper'>
        <div className='main-wrapper'>
          <main className='main-content-wrapper'>
            <form className='log-in-form'>
              <div className='log-in-logo'>
                <img
                  src='/3D sign up page mobile.png'
                  alt='page-logo'
                  className='log-in-3D-logo'
                />
              </div>
              <h1 className='log-in-heading'>Create new account</h1>

              <div className='info-detais'>
                <p className='input-detail-label'>First Name</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='firstName'
                    placeholder='e.g. John'
                    type='text'
                    inputMode='text'
                    onChange={handleFirstNameChange}
                    autoComplete='off'
                    value={firstName}
                    required
                  />
                </div>
                {!isFirstNameValid && firstName ? (
                  <p className='missing-details-error'>{firstNameError}</p>
                ) : null}
              </div>
              <div className='info-detais'>
                <p className='input-detail-label'>Surname</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='surname'
                    placeholder='e.g. Doe'
                    type='text'
                    inputMode='text'
                    onChange={handleSurnameChange}
                    autoComplete='off'
                    value={surname}
                    required
                  />
                </div>
                {!isSurnameValid && surname ? (
                  <p className='missing-details-error'>{surnameError}</p>
                ) : null}
              </div>
              <div className='info-detais'>
                <p className='input-detail-label'>Email</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='email'
                    placeholder='e.g johndoe@gmail.com'
                    type='text'
                    inputMode='text'
                    onChange={handleEmailChange}
                    autoComplete='off'
                    required
                  />
                </div>
                {email && !isEmailvalid && !response ? (
                  <p className='missing-details-error'>
                    Please enter a valid email address.
                  </p>
                ) : (
                  ''
                )}
                {response && (
                  <p className='missing-details-error'>{response}</p>
                )}
              </div>
              <div className='info-detais'>
                <p className='input-detail-label'>Phone</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='phone2'
                    placeholder='e.g 0772222333444'
                    type='tel'
                    // inputMode='text'
                    onChange={handlePhoneNumberChange}
                    autoComplete='off'
                    value={phoneNumber}
                    required
                  />
                </div>
                {phoneNumber && !isPhoneNumberValid ? (
                  <p className='missing-details-error'>
                    Please enter a valid phone number.
                  </p>
                ) : (
                  ''
                )}
              </div>

              <button
                className='next-btn'
                onClick={nextPage}
                disabled={!isNextButtonEnabled()}
                style={{
                  opacity: isNextButtonEnabled() ? 1 : 0.6,
                  cursor: isNextButtonEnabled() ? 'pointer' : 'initial',
                }}>
                Next
              </button>
            </form>
            <div className='sign-up-placeholder-picture'>
              <div className='new-acc-header-wrapper'>
                <h1 className='log-in-heading-large medium-height'>
                  Create a new
                </h1>
                <h1 className='log-in-heading-large large-height'>
                  Swap & Top
                </h1>
                <h1 className='log-in-heading-large second-medium-height'>
                  account
                </h1>
              </div>
              <img
                src='/3D sign up page-Current View.png'
                alt=''
                className='Log-in-image'
              />
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
}

/*---Sign up page 2---*/
export function SignUpPage2() {
  //---hooks---//
  const navigate = useNavigate();

  //---state---//
  //import state from first page//
  const userInfoFromFirstPage = useLocation().state;

  useEffect(() => {
    // Checking userInfoFromFirstPage is not available, then redirect
    if (!userInfoFromFirstPage) {
      navigate('/swapandtop/signup');
    }
  }, [userInfoFromFirstPage, navigate]);

  const [TandCsAgree, setTandCsAgree] = useState(false);
  const [TandCsErrorMsg, setTandCsErrorMsg] = useState(null);
  // const [physicalAddress, setPhysicalAddress] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [location, setLocation] = useState('');
  const [isLocationValid, setIsLocationValid] = useState(true);
  const [locationError, setLocationError] = useState('');
  const [location2, setLocation2] = useState('');
  const [image, setImage] = useState('');

  const [token, setToken] = useToken();
  const [accountCreationSuccess, setAccountCreationSuccess] = useState(true);

  // TanStack Query mutation for user registration
  const registerUserMutation = useMutation({
    mutationFn: async (userData) => {
      const response = await Api.post('/users', userData);
      return response;
    },
    onSuccess: (response) => {
      console.log('User registered successfully:', response);
      setAccountCreationSuccess(true);
      setToken(response.data.data.token);
      navigate('/swapandtop/emailverification', {
        replace: true,
        state: { email: response.data.data.email },
      });
    },
    onError: (error) => {
      console.error('An error occurred:', error);
      setAccountCreationSuccess(false);
    },
  });

  //View password toggle state//
  const [viewPassword, setViewPassword] = useState(false);
  const [viewPassword2, setViewPassword2] = useState(false);

  //---functions---//
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!TandCsAgree) {
      setTandCsErrorMsg(true);
      return;
    }

    const userData = {
      // physicalAddress,
      district: location,
      town: location2,
      password,
      image,
    };
    const completeUserData = { ...userInfoFromFirstPage, ...userData };

    registerUserMutation.mutate(completeUserData);
  };

  //check password validity//
  const isValidPassword = (password) => {
    // password criteria //
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%*+?_]).{8,24}$/;
    return passwordRegex.test(password);
  };

  const handleLocationChange = (e) => {
    const enteredLocation = e.target.value;
    setLocation(enteredLocation.trim());

    // Updated validation criteria for the location
    if (!/^[a-zA-ZÀ-ÿ0-9' -]{1,50}$/.test(enteredLocation)) {
      setIsLocationValid(false);
      setLocationError(
        'Location can only contain letters, digits, spaces, hyphens, and apostrophes, and must be between 1 and 50 characters long.'
      );
    } else {
      setIsLocationValid(true);
      setLocationError('');
    }
  };

  return (
    <>
      <div className='pageWrapper'>
        <div className='main-wrapper'>
          <main className='main-content-wrapper'>
            <form className='log-in-form'>
              <div className='log-in-logo'>
                <img
                  src='/3D sign up page mobile.png'
                  alt='page-logo'
                  className='log-in-3D-logo'
                />
              </div>

              <h1 className='log-in-heading'>Create new account</h1>
              {/* 
              <TextInputField
                label='Location'
                id='location'
                textBoxPlaceHolder='e.g CBC, Harare'
                setTextBox={setPhysicalAddress}
                textBoxType='text'
                textBoxInputMode='text'
                wrapperClass='info-detais'
              /> */}

              <div className='info-detais'>
                <p className='input-detail-label'>Neighbourhood/District</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='district'
                    placeholder='e.g. Mbare'
                    type='text'
                    inputMode='text'
                    onChange={handleLocationChange}
                    autoComplete='off'
                    value={location}
                    required
                  />
                </div>
                {!isLocationValid && location ? (
                  <p className='missing-details-error'>{locationError}</p>
                ) : null}
              </div>
              <div className='info-detais' style={{ fontSize: '0.8em' }}>
                <p className={'input-detail-label'}>City/Town</p>
                <div
                  className={'drop-down-wraper item-details-text-box-wraper'}>
                  <DropDownLocation
                    options={options}
                    cityOrTown={location2}
                    setCityOrTown={setLocation2}
                    inputType='cellCondition'
                  />
                </div>
              </div>

              <div className='info-detais'>
                <p className='input-detail-label'>Password</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='password'
                    placeholder='Enter password'
                    type={viewPassword ? 'text' : 'password'}
                    inputMode='password'
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div
                    className='view-password-icon-wrapper'
                    onClick={() => setViewPassword(!viewPassword)}>
                    {!viewPassword ? (
                      <ViewPasswordIcon svgClass='view-password-icon' />
                    ) : (
                      <HidePasswordIcon svgClass='view-password-icon' />
                    )}
                  </div>
                </div>
                {!isValidPassword(password) && password && (
                  <p className='missing-details-error'>
                    8 to 24 characters. Must include uppercase & lowercase
                    characters, a number, and at least one of the following
                    special characters: !@#$%*+?_
                  </p>
                )}
              </div>

              <div className='info-detais'>
                <p className='input-detail-label'>Confirm password</p>
                <div className='text-box-wraper item-details-text-box-wraper'>
                  <input
                    className='price-text-box item-details-text-box'
                    id='password2'
                    placeholder='Enter password'
                    type={viewPassword2 ? 'text' : 'password'}
                    inputMode='password2'
                    onChange={(e) => setPassword2(e.target.value)}
                  />
                  <div
                    className='view-password-icon-wrapper'
                    onClick={() => setViewPassword2(!viewPassword2)}>
                    {!viewPassword2 ? (
                      <ViewPasswordIcon svgClass='view-password-icon' />
                    ) : (
                      <HidePasswordIcon svgClass='view-password-icon' />
                    )}
                  </div>
                </div>
                {password2 && password2 !== password ? (
                  <p className='missing-details-error'>
                    Must match password entered in the field above.
                  </p>
                ) : (
                  ''
                )}
              </div>

              <div className='checbox-wrapper'>
                <div
                  className='custom-checkbox'
                  onClick={() => setTandCsAgree(!TandCsAgree)}>
                  {TandCsAgree && (
                    <div className='check-box-bg'>
                      <Checkmark className='TsandCs-checkmark' />
                    </div>
                  )}
                </div>
                <p>
                  I agree to&nbsp;
                  <NavLink
                    className='Ts-and-Cs-link'
                    to='/swapandtop/tou'
                    target='_blank'
                    rel='noopener noreferrer'
                    replace>
                    Swap & Top's terms of use
                  </NavLink>
                  &nbsp;
                </p>
              </div>
              {!accountCreationSuccess && (
                <p className='missing-details-error'>
                  An error occurred while creating your account!
                </p>
              )}
              {TandCsErrorMsg && (
                <p className='missing-details-error'>
                  Please agree to the terms of use to create account
                </p>
              )}
              <button
                className='next-btn'
                onClick={handleSubmit}
                style={{
                  cursor:
                    registerUserMutation.isPending ||
                      !(
                        TandCsAgree &&
                        location &&
                        isLocationValid &&
                        location2 &&
                        isValidPassword(password) &&
                        password2 === password
                      )
                      ? 'default'
                      : 'pointer',
                  opacity:
                    registerUserMutation.isPending ||
                      !(
                        TandCsAgree &&
                        location &&
                        isLocationValid &&
                        location2 &&
                        isValidPassword(password) &&
                        password2 === password
                      )
                      ? 0.6
                      : 1,
                  pointerEvents:
                    registerUserMutation.isPending ||
                      !(
                        TandCsAgree &&
                        location &&
                        isLocationValid &&
                        location2 &&
                        isValidPassword(password) &&
                        password2 === password
                      )
                      ? 'none'
                      : 'initial',
                }}>
                {registerUserMutation.isPending ? <LoadingCircle /> : 'Create Account'}
              </button>
            </form>
            <div className='sign-up-placeholder-picture'>
              <div className='new-acc-header-wrapper'>
                <h1 className='log-in-heading-large medium-height'>
                  Create a new
                </h1>
                <h1 className='log-in-heading-large large-height'>
                  Swap & Top
                </h1>
                <h1 className='log-in-heading-large second-medium-height'>
                  account
                </h1>
              </div>
              <img
                src='/3D sign up page-Current View.png'
                alt=''
                className='Log-in-image'
              />
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
}
